module.exports = __webpack_public_path__ + "media/public/images/slider/next-e2aafccb73cfc052487ea89be8d18c40.png";